function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrdersDelivery({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.708,
    height: 18.07,
    viewBox: "0 0 14.708 18.07",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16444",
    d: "M17.958 2.721v15.968a.63.63 0 0 1-.986.52l-2.1-1.431-1.98 1.422a.629.629 0 0 1-.782-.038l-1.51-1.316-1.5 1.317a.629.629 0 0 1-.782.038l-1.985-1.423-2.1 1.431a.63.63 0 0 1-.986-.52V2.721A1.471 1.471 0 0 1 4.721 1.25h11.766a1.471 1.471 0 0 1 1.471 1.471zM7.242 9.234h6.724a.63.63 0 1 0 0-1.261H7.242a.63.63 0 1 0 0 1.261zm0-3.362h6.724a.63.63 0 0 0 0-1.261H7.242a.63.63 0 0 0 0 1.261zm0 6.724H10.6a.63.63 0 0 0 0-1.261H7.242a.63.63 0 0 0 0 1.261z",
    transform: "translate(-3.25 -1.25)",
    style: {
      fillRule: "evenodd"
    },
    fill: "currentColor"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersDelivery);
export default __webpack_public_path__ + "static/media/orders-delivery.d0adc862e21e23bcd99520a7ad262838.svg";
export { ForwardRef as ReactComponent };